import SvgLocation from '@sats-group/icons/18/location';
import SvgPtLabel from '@sats-group/icons/18/pt-label';
import Link from '@sats-group/ui-lib/react/link';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { DisplayBootCampEvents as Props } from './display-boot-camp-events.types';

const DisplayBootCampEvents: React.FunctionComponent<Props> = ({
  events,
  nullState,
}) => (
  <div className="display-boot-camp-events">
    {events.map(event => (
      <div key={event.id} className="display-boot-camp-events__event">
        <a
          className="display-boot-camp-events__info"
          data-club-id={event.clubId}
          data-concept-id={event.conceptId}
          key={event.id}
          href={event.detailsPageUrl}
        >
          <div className="display-boot-camp-events__event-main">
            <Text theme={Text.themes.emphasis}>{event.conceptName}</Text>
          </div>

          <div className="display-boot-camp-events__pt">
            <Tag {...event.pt} icon={<SvgPtLabel />}></Tag>
          </div>

          <div className="display-boot-camp-events__location">
            <Tag {...event.location} icon={<SvgLocation />}></Tag>
          </div>

          <div className="display-boot-camp-events__dates">
            <Tag {...event.period}></Tag>
          </div>

          <div className="display-boot-camp-events__spots">
            <Tag {...event.availableSpots}></Tag>
          </div>
          <div className="display-boot-camp-events__action">
            <LinkButton {...event.button} wide />
          </div>
        </a>
      </div>
    ))}
    {nullState ? (
      <div className="display-boot-camp-events__no-upcoming">
        <Text>{nullState.title}</Text>
        {nullState.prompt ? (
          <div className="display-boot-camp-events__no-upcoming-prompt">
            <Text theme={Text.themes.emphasis}>{nullState.prompt.title}</Text>
            <Text>{nullState.prompt.text}</Text>
          </div>
        ) : null}
        <Link {...nullState.link} />
      </div>
    ) : null}
  </div>
);

export default DisplayBootCampEvents;
